import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBaseQuery } from "./customFetchBaseQuery";

export const apiAuthSlice = createApi({
  reducerPath: "api-auth",
  baseQuery: customFetchBaseQuery,
  keepUnusedDataFor: 0,
  refetchOnFocus: true,
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => {
    return {
      postLogin: builder.mutation({
        query: ({ email, password }) => ({
          url: `/api/login/`,
          method: "POST",
          body: { email, password },
        }),
      }),
      postRegsiterUser: builder.mutation({
        query: ({ email, password, confirmPassword }: any) => ({
          url: "/api/register/user",
          method: "POST",
          body: { email, password, confirmPassword },
        }),
      }),
      validateGoogleLoginToken: builder.mutation({
        query: ({ credential }: any) => ({
          url: "/api/login/auth/google-login",
          method: "POST",
          body: { credential },
        }),
      }),
      verifyInviteLink: builder.mutation({
        query: ({ token, email }: any) => ({
          // Both values MUST be encoded. Unencoded, a "+" in an address (gmail
          // plus-addressing) decodes server-side as a space, the user lookup
          // misses, and that account can never verify — and so can never log in.
          url: `/api/login/verify-email?token=${encodeURIComponent(
            token
          )}&email=${encodeURIComponent(email)}`,
          method: "POST",
        }),
      }),
      // A fresh confirmation link. The reply is the same whether or not the
      // address has an unconfirmed account (it's rate-limited server-side too),
      // so there's nothing to branch on; just show the message.
      resendVerification: builder.mutation({
        query: ({ email }: { email: string }) => ({
          url: "/api/login/resend-verification",
          method: "POST",
          body: { email },
        }),
      }),
      forgotPassword: builder.mutation({
        query: ({ email }: { email: string }) => ({
          url: "/api/login/forgot-password",
          method: "POST",
          body: { email },
        }),
      }),
      resetPassword: builder.mutation({
        query: ({ token, email, password, confirmPassword }: { token: string; email: string; password: string; confirmPassword: string }) => ({
          url: "/api/login/reset-password",
          method: "POST",
          body: { token, email, password, confirmPassword },
        }),
      }),
      validateResetToken: builder.query({
        query: ({ token, email }: { token: string; email: string }) => ({
          url: `/api/login/validate-reset-token?token=${token}&email=${email}`,
          method: "GET",
        }),
      }),
    };
  },
});

export const {
  usePostRegsiterUserMutation,
  usePostLoginMutation,
  useValidateGoogleLoginTokenMutation,
  useVerifyInviteLinkMutation,
  useResendVerificationMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useLazyValidateResetTokenQuery,
} = apiAuthSlice;
